import { v4 as uuidv4 } from 'uuid';

export function DisclosureLayoutGroup(props = {}, childrenComponents = []) {
	return {
		componentName: 'DisclosureLayoutGroup',
		componentId: uuidv4(),
		props: Object.assign(
			{
				maxVisible: 'one',
			},
			props,
		),
		childrenComponents,
	};
}
